module.exports = __webpack_public_path__ + "static/media/18.124356ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/18.svg
// module id = 2809
// module chunks = 3